export default {
  'pages.overview.dashboard.title': 'Dashboard',
  'pages.overview.dashboard.subtitle':
    'HQ overview of tenants, stores, and devices',
  'pages.overview.dashboard.filter.year': 'Statistics Year',
  'pages.overview.dashboard.action.reset': 'Reset',
  'pages.overview.dashboard.action.query': 'Search',
  'pages.overview.dashboard.action.retry': 'Reload',
  'pages.overview.dashboard.empty': 'No data',
  'pages.overview.dashboard.error.region': 'Failed to load this section',
  'pages.overview.dashboard.unit.count': '',
  'pages.overview.dashboard.unit.device': '',
  'pages.overview.dashboard.section.tenant': 'Tenant Statistics',
  'pages.overview.dashboard.section.tenantDesc':
    'Tenant volume, subscription status, industry mix, and growth',
  'pages.overview.dashboard.section.store': 'Store Statistics',
  'pages.overview.dashboard.section.storeDesc':
    'Store volume, type, status, tax type, and growth',
  'pages.overview.dashboard.section.device': 'Device Statistics',
  'pages.overview.dashboard.section.deviceDesc':
    'Device connectivity, authorization, updates, and expiry risks',
  'pages.overview.dashboard.card.tenantTotal': 'Total Tenants',
  'pages.overview.dashboard.card.tenantActive': 'Active Tenants',
  'pages.overview.dashboard.card.tenantExpiring': 'Expiring Tenants',
  'pages.overview.dashboard.card.tenantExpired': 'Expired Tenants',
  'pages.overview.dashboard.card.tenantNew30Days': 'New Tenants (30 Days)',
  'pages.overview.dashboard.card.storeTotal': 'Total Stores',
  'pages.overview.dashboard.card.directStore': 'Direct Stores',
  'pages.overview.dashboard.card.experienceStore': 'Experience Stores',
  'pages.overview.dashboard.card.franchiseStore': 'Franchise Stores',
  'pages.overview.dashboard.card.storeNew30Days': 'New Stores (30 Days)',
  'pages.overview.dashboard.card.deviceTotal': 'Total Devices',
  'pages.overview.dashboard.card.deviceEnabled': 'Enabled Devices',
  'pages.overview.dashboard.card.deviceOnline': 'Online Devices',
  'pages.overview.dashboard.card.deviceExpiring': 'Expiring Devices',
  'pages.overview.dashboard.card.deviceNew30Days': 'New Devices (30 Days)',
  'pages.overview.dashboard.card.deviceCompliant': 'Compliant Devices',
  'pages.overview.dashboard.card.deviceNotEnabled': 'Not Enabled',
  'pages.overview.dashboard.card.deviceOffline': 'Offline Devices',
  'pages.overview.dashboard.card.deviceExpired': 'Expired Devices',
  'pages.overview.dashboard.card.deviceUpgrade': 'Pending Upgrades',
  'pages.overview.dashboard.chart.tenantMonthly': 'New Tenants in {year}',
  'pages.overview.dashboard.chart.subscription': 'Subscription Status',
  'pages.overview.dashboard.chart.industry': 'Industry Distribution',
  'pages.overview.dashboard.chart.storeMonthly': 'New Stores in {year}',
  'pages.overview.dashboard.chart.storeStatus': 'Store Status',
  'pages.overview.dashboard.chart.tax': 'VAT / Non-VAT Stores',
  'pages.overview.dashboard.chart.deviceVersion': 'Device Versions',
  'pages.overview.dashboard.chart.deviceStatus': 'Device Status',
  'pages.overview.dashboard.distribution.normalTenant': 'Normal',
  'pages.overview.dashboard.distribution.expiringTenant': 'Expiring Soon',
  'pages.overview.dashboard.distribution.expiredTenant': 'Expired',
  'pages.overview.dashboard.distribution.restaurant': 'Restaurant',
  'pages.overview.dashboard.distribution.retail': 'Retail',
  'pages.overview.dashboard.distribution.fastFood': 'Fast Food',
  'pages.overview.dashboard.distribution.unconfigured': 'Unconfigured',
  'pages.overview.dashboard.distribution.normalStore': 'Normal',
  'pages.overview.dashboard.distribution.closedStore': 'Closed',
  'pages.overview.dashboard.distribution.cancelledStore': 'Cancelled',
  'pages.overview.dashboard.distribution.onlineDevice': 'Online',
  'pages.overview.dashboard.distribution.offlineDevice': 'Offline',
  'pages.overview.dashboard.distribution.notEnabledDevice': 'Not Enabled',
};
